export type FruitSpec = {
  name: string;
  radius: number;
  color: number;
  accent: number;
  shadow: number;
  score: number;
  stripe?: number;
};

export const FRUITS: FruitSpec[] = [
  {
    name: "Cherry",
    radius: 18,
    color: 0xff4f6d,
    accent: 0xff9aac,
    shadow: 0xb91f3c,
    score: 1
  },
  {
    name: "Berry",
    radius: 24,
    color: 0xf12b47,
    accent: 0xffc1cc,
    shadow: 0x9f1733,
    score: 3
  },
  {
    name: "Grape",
    radius: 30,
    color: 0x8a5be9,
    accent: 0xc8a8ff,
    shadow: 0x52349b,
    score: 6
  },
  {
    name: "Orange",
    radius: 38,
    color: 0xff9f1c,
    accent: 0xffd37a,
    shadow: 0xbc6510,
    score: 10
  },
  {
    name: "Lemon",
    radius: 46,
    color: 0xf9d44a,
    accent: 0xffefa3,
    shadow: 0xbd9a21,
    score: 15
  },
  {
    name: "Apple",
    radius: 55,
    color: 0x64c86c,
    accent: 0xbaf0aa,
    shadow: 0x2f8a43,
    score: 21
  },
  {
    name: "Pear",
    radius: 65,
    color: 0xd9c85d,
    accent: 0xf5ed9b,
    shadow: 0x9b8935,
    score: 28
  },
  {
    name: "Peach",
    radius: 76,
    color: 0xff9aa8,
    accent: 0xffd0d5,
    shadow: 0xc85a70,
    score: 36
  },
  {
    name: "Melon",
    radius: 88,
    color: 0x76c878,
    accent: 0xd4f4bf,
    shadow: 0x3f9145,
    score: 45,
    stripe: 0xa8df8e
  },
  {
    name: "Pumpkin",
    radius: 102,
    color: 0xff7a35,
    accent: 0xffbd79,
    shadow: 0xbe4b18,
    score: 55,
    stripe: 0xe85e24
  },
  {
    name: "Watermelon",
    radius: 116,
    color: 0x27a45f,
    accent: 0xa8e66f,
    shadow: 0x15693d,
    score: 66,
    stripe: 0x0f7a49
  }
];

export const STARTING_FRUIT_MAX = 4;

export const fruitTextureKey = (level: number) => `fruit-${level}`;
